import { render, staticRenderFns } from "./StaffDetailV2.vue?vue&type=template&id=3a16e7fe&scoped=true"
import script from "./StaffDetailV2.vue?vue&type=script&lang=js"
export * from "./StaffDetailV2.vue?vue&type=script&lang=js"
import style0 from "./StaffDetailV2.vue?vue&type=style&index=0&id=3a16e7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a16e7fe",
  null
  
)

export default component.exports